import React, { useState } from 'react';
import '../../../styles/cases.css';

/* ── Sample data ────────────────────────────────────────────────────────────── */
const SAMPLE_CASES = [
  {
    id: 'CASE-001',
    caseNumber: 'CASE-001',
    caseOpened: '03 Jan 2026',
    memberName: 'Mdm Siti Rahimah',
    volunteerAssigned: 'David Lim',
    programmesApplied: ['Care & Connect', 'Widow-to-Widow'],
    supportNetworks: ['Bukit Merah Care Network', 'Family Support Circle'],
    concerns: 'Member experiencing social isolation following recent bereavement. Limited mobility restricts community participation.',
    status: 'Open',
  },
  {
    id: 'CASE-002',
    caseNumber: 'CASE-002',
    caseOpened: '10 Jan 2026',
    memberName: 'Mdm Lim Bee Choo',
    volunteerAssigned: 'Sarah Tan',
    programmesApplied: ['Job Board', 'Financial Assistance'],
    supportNetworks: ['Employment Support Group'],
    concerns: 'Primary caregiver for elderly parent; seeking flexible employment opportunities and financial aid guidance.',
    status: 'Open',
  },
  {
    id: 'CASE-003',
    caseNumber: 'CASE-003',
    caseOpened: '15 Jan 2026',
    memberName: 'Mdm Fatimah Bte Yusof',
    volunteerAssigned: 'James Wong',
    programmesApplied: ['Rebuild & Shine', 'Widow-to-Widow'],
    supportNetworks: ['Yishun Widows Circle', 'Mental Wellness Network'],
    concerns: 'Grieving process ongoing 8 months post-bereavement. Requires emotional support and structured re-engagement activities.',
    status: 'Open',
  },
  {
    id: 'CASE-004',
    caseNumber: 'CASE-004',
    caseOpened: '20 Jan 2026',
    memberName: 'Mdm Chen Mei Ling',
    volunteerAssigned: 'Priya Nair',
    programmesApplied: ['Care & Connect'],
    supportNetworks: ['Tampines Senior Connect'],
    concerns: 'Member living alone with two school-age children. Childcare support and household management assistance needed.',
    status: 'Closed',
  },
  {
    id: 'CASE-005',
    caseNumber: 'CASE-005',
    caseOpened: '28 Jan 2026',
    memberName: 'Mdm Nora Bte Hashim',
    volunteerAssigned: 'Michael Goh',
    programmesApplied: ['Job Board', 'Rebuild & Shine'],
    supportNetworks: ['Woodlands Employment Network'],
    concerns: 'Member re-entering workforce after 10-year career break. Skills upgrading and interview coaching required.',
    status: 'Open',
  },
  {
    id: 'CASE-006',
    caseNumber: 'CASE-006',
    caseOpened: '04 Feb 2026',
    memberName: 'Mdm Tan Swee Kuan',
    volunteerAssigned: 'Rachel Lee',
    programmesApplied: ['Financial Assistance', 'Care & Connect'],
    supportNetworks: ['Hougang Mutual Aid', 'Seniors Activity Centre'],
    concerns: 'Financial hardship post-bereavement; outstanding utility bills and rental arrears. Immediate assistance referral made.',
    status: 'Open',
  },
  {
    id: 'CASE-007',
    caseNumber: 'CASE-007',
    caseOpened: '12 Feb 2026',
    memberName: 'Mdm Rosnah Bte Alias',
    volunteerAssigned: 'Kevin Chia',
    programmesApplied: ['Widow-to-Widow', 'Care & Connect'],
    supportNetworks: ['Geylang Serai Community Network'],
    concerns: 'Member recently widowed; requires peer support and adjustment counselling. Language preference: Malay.',
    status: 'Open',
  },
  {
    id: 'CASE-008',
    caseNumber: 'CASE-008',
    caseOpened: '18 Feb 2026',
    memberName: 'Mdm Wong Peck Yian',
    volunteerAssigned: 'Angela Koh',
    programmesApplied: ['Rebuild & Shine'],
    supportNetworks: ['Jurong West Wellness Circle'],
    concerns: 'Member recovering from extended illness. Social reintegration support and health monitoring follow-ups in progress.',
    status: 'Closed',
  },
  {
    id: 'CASE-009',
    caseNumber: 'CASE-009',
    caseOpened: '25 Feb 2026',
    memberName: 'Mdm Ayesha d/o Ramachandran',
    volunteerAssigned: 'Benjamin Yap',
    programmesApplied: ['Job Board', 'Care & Connect', 'Financial Assistance'],
    supportNetworks: ['Serangoon Support Hub', 'Single Parent Network'],
    concerns: 'Single parent with three dependants. Multiple referrals active across employment, financial, and social programmes.',
    status: 'Open',
  },
  {
    id: 'CASE-010',
    caseNumber: 'CASE-010',
    caseOpened: '05 Mar 2026',
    memberName: 'Mdm Goh Siew Tin',
    volunteerAssigned: 'Unassigned',
    programmesApplied: ['Care & Connect'],
    supportNetworks: ['Pasir Ris Befrienders'],
    concerns: 'New intake. Initial assessment scheduled. Member reports low mood and reduced appetite over the past month.',
    status: 'Open',
  },
];

const ALL_PROGRAMMES = [
  'Care & Connect', 'Rebuild & Shine', 'Widow-to-Widow',
  'Job Board', 'Financial Assistance',
];

const ALL_VOLUNTEERS = [
  'David Lim', 'Sarah Tan', 'James Wong', 'Priya Nair', 'Michael Goh',
  'Rachel Lee', 'Kevin Chia', 'Angela Koh', 'Benjamin Yap', 'Unassigned',
];

/* ── Helpers ────────────────────────────────────────────────────────────────── */
function StatusBadge({ status }) {
  const cls = status === 'Closed' ? 'bb-cs-badge bb-cs-badge--closed' : 'bb-cs-badge bb-cs-badge--open';
  return <span className={cls}>{status}</span>;
}

function EditModal({ caseData, onSave, onClose }) {
  const [form, setForm] = useState({ ...caseData });

  const toggleProgramme = (p) => {
    setForm(f => ({
      ...f,
      programmesApplied: f.programmesApplied.includes(p)
        ? f.programmesApplied.filter(x => x !== p)
        : [...f.programmesApplied, p],
    }));
  };

  const handleNetworkChange = (e) => {
    setForm(f => ({ ...f, supportNetworks: e.target.value.split('\n').filter(Boolean) }));
  };

  const handleSave = () => {
    if (!form.caseNumber.trim()) return;
    onSave(form);
  };

  return (
    <div className="bb-cs-overlay" onClick={onClose}>
      <div className="bb-cs-modal" onClick={e => e.stopPropagation()}>
        <div className="bb-cs-modal-header">
          <h2 className="bb-cs-modal-title">Edit Case — {caseData.caseNumber}</h2>
          <button className="bb-cs-modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="bb-cs-modal-body">
          {/* Case Number */}
          <div className="bb-cs-field">
            <label className="bb-cs-label">Case Number</label>
            <input
              className="bb-cs-input"
              value={form.caseNumber}
              onChange={e => setForm(f => ({ ...f, caseNumber: e.target.value }))}
            />
          </div>

          {/* Case Opened */}
          <div className="bb-cs-field">
            <label className="bb-cs-label">Case Opened</label>
            <input
              className="bb-cs-input"
              value={form.caseOpened}
              onChange={e => setForm(f => ({ ...f, caseOpened: e.target.value }))}
            />
          </div>

          {/* Member Name — read-only */}
          <div className="bb-cs-field">
            <label className="bb-cs-label">Member Name <span className="bb-cs-readonly-note">(read-only)</span></label>
            <input className="bb-cs-input bb-cs-input--readonly" value={form.memberName} readOnly />
          </div>

          {/* Volunteer Assigned */}
          <div className="bb-cs-field">
            <label className="bb-cs-label">Volunteer Assigned</label>
            <select
              className="bb-cs-input"
              value={form.volunteerAssigned}
              onChange={e => setForm(f => ({ ...f, volunteerAssigned: e.target.value }))}
            >
              {ALL_VOLUNTEERS.map(v => <option key={v} value={v}>{v}</option>)}
            </select>
          </div>

          {/* Programmes Applied */}
          <div className="bb-cs-field">
            <label className="bb-cs-label">Programmes Applied</label>
            <div className="bb-cs-checkbox-group">
              {ALL_PROGRAMMES.map(p => (
                <label key={p} className="bb-cs-checkbox-label">
                  <input
                    type="checkbox"
                    checked={form.programmesApplied.includes(p)}
                    onChange={() => toggleProgramme(p)}
                  />
                  {p}
                </label>
              ))}
            </div>
          </div>

          {/* Support Networks */}
          <div className="bb-cs-field">
            <label className="bb-cs-label">Support Networks <span className="bb-cs-readonly-note">(one per line)</span></label>
            <textarea
              className="bb-cs-textarea"
              rows={3}
              value={form.supportNetworks.join('\n')}
              onChange={handleNetworkChange}
            />
          </div>

          {/* Concerns */}
          <div className="bb-cs-field">
            <label className="bb-cs-label">Concerns</label>
            <textarea
              className="bb-cs-textarea"
              rows={4}
              value={form.concerns}
              onChange={e => setForm(f => ({ ...f, concerns: e.target.value }))}
            />
          </div>

          {/* Status */}
          <div className="bb-cs-field">
            <label className="bb-cs-label">Status</label>
            <select
              className="bb-cs-input"
              value={form.status}
              onChange={e => setForm(f => ({ ...f, status: e.target.value }))}
            >
              <option value="Open">Open</option>
              <option value="Closed">Closed</option>
            </select>
          </div>
        </div>

        <div className="bb-cs-modal-footer">
          <button className="bb-cs-btn bb-cs-btn--secondary" onClick={onClose}>Cancel</button>
          <button className="bb-cs-btn bb-cs-btn--primary" onClick={handleSave}>Save Changes</button>
        </div>
      </div>
    </div>
  );
}

function CloseConfirmModal({ caseData, onConfirm, onCancel }) {
  return (
    <div className="bb-cs-overlay" onClick={onCancel}>
      <div className="bb-cs-modal bb-cs-modal--sm" onClick={e => e.stopPropagation()}>
        <div className="bb-cs-modal-header">
          <h2 className="bb-cs-modal-title">Close Case</h2>
          <button className="bb-cs-modal-close" onClick={onCancel}>✕</button>
        </div>
        <div className="bb-cs-modal-body">
          <p className="bb-cs-confirm-text">
            Are you sure you want to close <strong>{caseData.caseNumber}</strong> for{' '}
            <strong>{caseData.memberName}</strong>? The case will remain visible with a Closed status.
          </p>
        </div>
        <div className="bb-cs-modal-footer">
          <button className="bb-cs-btn bb-cs-btn--secondary" onClick={onCancel}>Cancel</button>
          <button className="bb-cs-btn bb-cs-btn--danger" onClick={onConfirm}>Close Case</button>
        </div>
      </div>
    </div>
  );
}

/* ── Main component ─────────────────────────────────────────────────────────── */
export default function Cases({ orgId }) {
  const [cases, setCases] = useState(SAMPLE_CASES);
  const [editTarget, setEditTarget] = useState(null);
  const [closeTarget, setCloseTarget] = useState(null);
  const [statusFilter, setStatusFilter] = useState('All');
  const [search, setSearch] = useState('');

  const filtered = cases.filter(c => {
    const matchStatus = statusFilter === 'All' || c.status === statusFilter;
    const q = search.toLowerCase();
    const matchSearch = !q
      || c.caseNumber.toLowerCase().includes(q)
      || c.memberName.toLowerCase().includes(q)
      || c.volunteerAssigned.toLowerCase().includes(q);
    return matchStatus && matchSearch;
  });

  const handleSaveEdit = (updated) => {
    setCases(cs => cs.map(c => c.id === updated.id ? updated : c));
    setEditTarget(null);
  };

  const handleConfirmClose = () => {
    setCases(cs => cs.map(c => c.id === closeTarget.id ? { ...c, status: 'Closed' } : c));
    setCloseTarget(null);
  };

  return (
    <div className="bb-cs-section">
      {/* Header */}
      <div className="bb-cs-section-header">
        <div>
          <h1 className="bb-cs-section-title">Cases</h1>
          <p className="bb-cs-section-subtitle">Active and closed support cases for your organisation's members.</p>
        </div>
      </div>

      {/* Filters */}
      <div className="bb-cs-filters">
        <input
          className="bb-cs-search"
          placeholder="Search by case no., member, or volunteer…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <div className="bb-cs-filter-group">
          {['All', 'Open', 'Closed'].map(s => (
            <button
              key={s}
              className={`bb-cs-filter-btn${statusFilter === s ? ' active' : ''}`}
              onClick={() => setStatusFilter(s)}
            >
              {s}
            </button>
          ))}
        </div>
      </div>

      {/* Table */}
      <div className="bb-cs-table-wrapper">
        <table className="bb-cs-table">
          <thead>
            <tr>
              <th>Case No.</th>
              <th>Case Opened</th>
              <th>Member Name</th>
              <th>Volunteer Assigned</th>
              <th>Programmes Applied</th>
              <th>Support Networks</th>
              <th>Concerns</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr>
                <td colSpan={9} className="bb-cs-empty">No cases found.</td>
              </tr>
            )}
            {filtered.map(c => (
              <tr key={c.id} className={c.status === 'Closed' ? 'bb-cs-row--closed' : ''}>
                <td className="bb-cs-cell-mono">{c.caseNumber}</td>
                <td className="bb-cs-cell-nowrap">{c.caseOpened}</td>
                <td className="bb-cs-cell-name">{c.memberName}</td>
                <td>{c.volunteerAssigned}</td>
                <td>
                  <div className="bb-cs-tag-list">
                    {c.programmesApplied.map(p => (
                      <span key={p} className="bb-cs-tag">{p}</span>
                    ))}
                  </div>
                </td>
                <td>
                  <div className="bb-cs-tag-list">
                    {c.supportNetworks.map(n => (
                      <span key={n} className="bb-cs-tag bb-cs-tag--network">{n}</span>
                    ))}
                  </div>
                </td>
                <td className="bb-cs-cell-concerns">
                  <span className="bb-cs-concerns-text">{c.concerns}</span>
                </td>
                <td><StatusBadge status={c.status} /></td>
                <td>
                  <div className="bb-cs-actions">
                    <button
                      className="bb-cs-action-btn"
                      onClick={() => setEditTarget(c)}
                    >
                      Edit
                    </button>
                    <button
                      className="bb-cs-action-btn bb-cs-action-btn--danger"
                      onClick={() => setCloseTarget(c)}
                      disabled={c.status === 'Closed'}
                    >
                      Close Case
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modals */}
      {editTarget && (
        <EditModal
          caseData={editTarget}
          onSave={handleSaveEdit}
          onClose={() => setEditTarget(null)}
        />
      )}
      {closeTarget && (
        <CloseConfirmModal
          caseData={closeTarget}
          onConfirm={handleConfirmClose}
          onCancel={() => setCloseTarget(null)}
        />
      )}
    </div>
  );
}
